<template>
  <div>
        <!-- Breadcrumb Section Begin -->
        <div class="breacrumb-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-text">
                      <router-link to="/"><i class="fa fa-home"></i> {{ $t('nav.home') }}</router-link>
                        <span>{{ $t('breadcrumb.blog') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Blog -->
    <section class="blog-section spad" v-if="blog.length > 0">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-8 order-2 order-lg-1">
                    <div class="blog-sidebar">
                        
                        <div class="recent-post">
                            <h4>{{ $t('blog.latestNews') }}</h4>
                            <div class="recent-blog">
                              <div v-for="bl in blog2" :key="bl.itiId">
                                <router-link :to="'/BlogDetalhe/' + bl.itiId + '/' + formataLink(bl.itiNome)" class="rb-item">
                                    <div class="rb-text">
                                        <h6 style="font-size: 13px;">{{ $localeField(bl, 'itiNome') }}</h6>
                                    </div>
                                </router-link>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9 order-1 order-lg-2">
                    <div class="row">
                        <div class="col-lg-6 col-sm-6" v-for="bl2 in blog1" :key="bl2.itiId">
                            <div class="blog-item">
                                <div class="bi-pic">
                                  <router-link :to="'/BlogDetalhe/' + bl2.itiId + '/' + formataLink(bl2.itiNome)" class="rb-item">
                                    <img v-if="bl2.insInstitucionalImagens!=''" :src="$imgURL + bl2.insInstitucionalImagens[0].itgUrlImagem" alt="" class="blog-img">
                                  </router-link>
                                </div>
                                <div class="bi-text">
                                  <router-link :to="'/BlogDetalhe/' + bl2.itiId + '/' + formataLink(bl2.itiNome)" class="rb-item">
                                        <h4>{{ $localeField(bl2, 'itiNome') }}</h4>
                                  </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Blog final -->
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';

export default {
  name: 'BlogView',
  setup() {
    const route = useRoute();
    const id = route.params.idBlog;
    return {
      id
    };
  },
  components: {
  },
  data: () => ({
    blog: [],
    blog1: [],
    blog2: [],
  }),
  methods: {
    carregaMetas() {
      useHead({
        title: 'Blog - Sub4 Turismo'
      })
    },
    formattedDate(value) {
      return this.$moment(value).format('DD/MM/YYYY')
    },
    formataLink(value){
      return value.replaceAll('/','').replaceAll(' ','-').replaceAll('.','');
    },
    scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Isso adicionará uma animação de rolagem suave
    });
  },
  isMobile() {
    return window.innerWidth <= 768; // Você pode ajustar esse valor de acordo com suas necessidades
  }
  },
  created() {
    this.carregaMetas();

    axios.get('/Process/InsInstitucional/institucional/42/blog')
      .then(response => {
        this.blog = response.data
  .filter(x => x.itiVisivel)
  .sort((a, b) => new Date(b.itiData1) - new Date(a.itiData1));

        this.blog1 = this.blog.slice(0,12)
        this.blog2 = this.blog.slice(12)
      })
      .catch(error => {
        console.error(error);
      });


  },
}
</script>

<style>
.das {
  display: block !important;
}

.slider-text h2 p {
  font-size: 60px;
  color: #081624;
  padding: 10px;
  display: inline-block;
  background: #99CC33;
  line-height: 1;
}</style>
